import { createApp } from "vue";
import App from "./App.vue";

import { createPinia } from "pinia";
import { Web3ModalVuePlugin } from "web3modal-vue3"


import globalFilters from "./helpers/global.filters"
import globalMixins from "./mixins/global.mixins"
import './scss/app.scss'
//import "bootstrap/dist/js/bootstrap.js"

const app  = createApp(App)
app.use(createPinia())

app.use(Web3ModalVuePlugin)
app.mixin(globalMixins)

app.config.globalProperties.$filters = globalFilters

import { bcStore } from "@/store/bc.store.js";
app.config.globalProperties.$bc = bcStore()

import { uiStore } from "@/store/ui.store.js";
app.config.globalProperties.$ui = uiStore()

import dayjs from "dayjs"; 
require('dayjs/locale/uk')
dayjs.locale('en')
dayjs.extend(require('dayjs/plugin/relativeTime'))
app.config.globalProperties.$date = dayjs


import mitt from 'mitt';
app.config.globalProperties.$mitt = mitt();

app.provide('$mitt', mitt())


import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
const swalOptions = {
    buttonsStyling: false,
    customClass: {
        popup: '_swal2_popup',
        confirmButton: 'btn btn-outline-light px-4',
        denyButton: 'btn btn-outline-light px-4',
        cancelButton: 'btn btn-outline-light px-4',
        footer: '_swal2_footer',
    }
};
app.use(VueSweetalert2, swalOptions);

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
app.use(VueLoading, {
    loader: 'dots',
    width: 100,
    height: 100,
    color: 'rgb(244 21 15)',
    backgroundColor: '#000000',
    opacity: 0.5,
    zIndex: 99999,
    blur: '0',
});

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
app.component('font-awesome-icon', FontAwesomeIcon);

app.mount("#app");
